import React from 'react';
import Anime from 'react-anime';
import BackToHomeBtn from './BackToHomeBtn';
import mail from '../assets/mail.svg';
import github from '../assets/github.svg';
import twitter from '../assets/twitter.svg';
import medium from '../assets/medium.svg';
import linkedin from '../assets/linkedin.svg';
import codepen from '../assets/codepen.svg';
import facebook from '../assets/facebook.svg';
import '../styles/ContactsPage.css';

const ContactsPage = ({ returnBtn }) => {
  return (
    <div style={{ overflow: 'hidden', position: 'fixed' }}>
      <div className="page-back-btn">
        <BackToHomeBtn handleClick={returnBtn} />
      </div>
      <Anime easing="easeOutCubic" opacity={[0, 1]} translateY={-30} duration={400} delay={300}>
        <div className="contacts-page">
          <Anime easing="easeOutCubic" opacity={[0, 1]} duration={500} delay={800}>
            <p className="page-tag">Contacts</p>
          </Anime>
          <div className="page-content">
            <h1>Let's get in touch!</h1>
            <p>I love meeting new people from around the world! Hit me up to talk about project ideas, Programming, Movies, Neuroscience, Linux, Kittens and Puppies, Travelling, Books, Or Weather. Or just say "Hi" and we'll find something we enjoy talking about. You can find me through any of the platform listed below.</p>
            <div className="link-list">
              <ul>
                <li><a href="mailto:abdulawalarif0011@gmail.com" target="_blank" rel="noopener noreferrer"><img src={mail} alt="Mail me!" /></a></li>
                <li><a href="https://github.com/abdulawalarif" target="_blank" rel="noopener noreferrer"><img src={github} alt="" /></a></li>
                <li><a href="https://www.linkedin.com/in/abdul-awal-arif" target="_blank" rel="noopener noreferrer"><img src={linkedin} alt="" /></a></li>
                <li><a href="https://x.com/Arif_AbdulAwal" target="_blank" rel="noopener noreferrer"><img src={twitter} alt="" /></a></li>
                <li><a href="https://medium.com/@abdulAwalArif" target="_blank" rel="noopener noreferrer"><img src={medium} alt="" /></a></li>
                <li><a href="https://stackoverflow.com/users/12343677/abdul-awal" target="_blank" rel="noopener noreferrer"><img src={codepen} alt="" /></a></li>
                <li><a href="https://www.facebook.com/Aawalarif" target="_blank" rel="noopener noreferrer"><img src={facebook} alt="" /></a></li>
              </ul>
            </div>
          </div>
        </div>
      </Anime>
    </div>
  );
};

export default ContactsPage;
